// extracted by css-extract-rspack-plugin
export default {"skeleton":"PvYkNfmKv8wANuAY","skeleton-pulse":"TTbjg2mUSIUoA2yy"};